import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import FloatingLabel from "react-bootstrap/FloatingLabel";

import Form from "react-bootstrap/Form";

import Utils from "../../../../Utils";
import ContextComponent from "../../../../AppContext";
import FolderTree from "../FolderTree";

const CloneSitePage = ({ props }) => {
    let { setAlert, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);
    let [sitename, setSitename] = useState("");
    let [siteIdForEdit, setSiteIdForEdit] = useState(props?.siteIdForEdit ?? '');
    let [siteDescription, setSiteDescription] = useState("");
    const [siteSME, setSiteSME] = useState("");
    let [classicview, setClassicview] = useState(false);
    const [enableQuiz, setEnableQuiz] = useState(false);
    const [siteNameError, setSiteNameError] = useState("");
    const [smeError, setSmeError] = useState("");
    let [projectId, setProjectId] = useState(props?.projectid ?? null);
    let [selectedFolderId, setSelectedFolderId] = useState([]);
    let [expandedFolders, setExpandedFolders] = useState([]);
    const [originalQuizValue, setOriginalQuizValue] = useState(false);

    const hideModal = (e) => {
        props.setCloneModalCanOpen(false);
    };

    const cloneSiteNameValidation = (currentSiteName) => {
        setSiteNameError("");
        const siteNameValue = currentSiteName.trim();
        if (siteNameValue.length === 0) {
            setSiteNameError("Site name is required.");
            return false;
        }

        if (siteNameValue.toLowerCase() === Utils.ADMIN_PAGE_ROUTING_VARIABLE) {
            let alertMessage = siteNameValue + " is a keyword can't be used as siteName";
            setSiteNameError(alertMessage);
            return false;
        }

        return true;
    };

    const siteSMEValidation = (smeValue) => {
        const siteSMEValue = smeValue.trim();
        setSmeError("");

        if(siteSMEValue.length === 0) {
           setSmeError("SME field is required.");
           return false;
        }

        return true;
    }

    const submitSite = (e) => {
        e.preventDefault();
        const isSiteNameValid = cloneSiteNameValidation(sitename);
        const isSMEValid = siteSMEValidation(siteSME);

        if (isSiteNameValid && isSMEValid) {
            cloneSite(e);
        }
    }

    const cloneSite = (e) => {
        setLoadingState({
            applyMask: true,
            text: "Cloning the site",
        });
        const success = (res) => {
            hideModal();
            setLoadingState({
                applyMask: false
            });
            setAlert({
                show: true,
                message: "Site cloned successfully!",
                type: "success",
            });
            props.setTableSelectedItems([]);
            props.loadProjectSites();
        };
        const fail = (err) => {
            setLoadingState({
                applyMask: false
            });
            if (err?.redirect) {
                setCanRedirectToLogin(true);
            }
            setAlert({
                show: true,
                message: "Site Clone failed",
                type: "danger",
            });
            console.log(err);
        };

        let formData = {
            sitename: sitename,
            description: siteDescription,
            classicview: classicview,
            projectId: selectedFolderId,
            sme: siteSME,
            quiz: enableQuiz,
        };
        console.log(formData);
        try {
            // debugger;
            // console.log(formData);
            Utils.cloneSite(selectedSiteId, formData).then(success, fail);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        setSelectedFolderId(projectId);
    },[projectId]);

    const sitenameHandler = (e) => {
        let value = e?.currentTarget?.value || "";
        setSitename(value);
    };

    const siteDescriptionHandler = (e) => {
        let value = e?.currentTarget?.value || "";
        setSiteDescription(value);
    };

    const siteSMEHandler = (e) => {
        let value = e?.currentTarget?.value || "";
        setSiteSME(value);
    };

    const [selectedSiteId, setSelectedSiteId] = useState('');

    const siteHandler = (event) => {
        setSelectedSiteId(event.target.value);
    };

    const siteClassicviewHandler = (e) => {
        setClassicview(e.currentTarget.checked);
    };

    const siteEnableQuizHandler = (e) => {
        setEnableQuiz(e.currentTarget.checked);
    };

    useEffect(() => { }, [props.cloneModalCanOpen]);

    const handleClose = (e) => {
        props.setCloneModalCanOpen(false);
    };

    useEffect(() => {
        const selectedId = props?.tableSelectedItems?.[0];
        const quizIndex = props?.tableColumns?.indexOf("quiz");

        if (selectedId) {
            const row = props?.tableData?.find(r => r[0] === selectedId);

            if (row) {
                const quizValue = row[quizIndex];
                setOriginalQuizValue(!!quizValue);
                setEnableQuiz(!!quizValue);
            }
        }

        setSelectedSiteId(selectedId);
        setProjectId(props?.projectid);
    }, []);

    const toggleFolder = (folderId) => {
        setExpandedFolders(prev => {
          if (prev.includes(folderId)) {
            return prev.filter(id => id !== folderId);
          }
          return [...prev, folderId];
        });
    };
    

    return (
        <>
            {
                <Modal centered show={props.cloneModalCanOpen} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Clone Site</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                            <div className="indi-add-form-wrapper d-flex flex-column">
                                <div className="indi-add-form-item d-flex flex-column">
                                    <div className="indi-add-form-item-input row">
                                        {/* The below select is commented because we don't need drop down anymore! */}
                                        {/* {sitesDataAvailable && (
                                            <FloatingLabel label="Site to Clone">
                                                <Form.Select
                                                    id="siteId"
                                                    onChange={siteHandler}
                                                    size="sm"
                                                    defaultValue={siteIdForEdit}
                                                    className="indi-input-field indi-input-select-field"
                                                >
                                                    {siteData.map((site, index) => (
                                                        <option value={site.id} key={index}>
                                                            {site.name}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </FloatingLabel>
                                        )} */}
                                    </div>
                                </div>
                                <div className="indi-add-form-item d-flex flex-column">
                                    <div className="indi-add-form-item-input row">
                                        <FloatingLabel label="Site Name">
                                            <Form.Control
                                                type="text"
                                                className="indi-input-field"
                                                id="firstName"
                                                placeholder="Enter site name"
                                                autoComplete="off"
                                                onChange={sitenameHandler}
                                            />
                                        </FloatingLabel>
                                        {siteNameError && 
                                            <p className="indi-input-field-error-message">
                                                {siteNameError}
                                            </p>
                                        }
                                    </div>
                                </div>
                                <div className="indi-add-form-item d-flex flex-column">
                                    <div className="indi-add-form-item-input row">
                                        <FloatingLabel label="Description">
                                            <Form.Control
                                                as="textarea"
                                                className="indi-input-field"
                                                id="lastName"
                                                placeholder="Enter site description"
                                                autoComplete="off"
                                                onChange={siteDescriptionHandler}
                                            />
                                        </FloatingLabel>
                                    </div>
                                </div>
                                <div className="indi-add-form-item d-flex flex-column">
                                    <div className="indi-add-form-item-input row">
                                        <FloatingLabel label="SME">
                                            <Form.Control
                                                type="text"
                                                className="indi-input-field"
                                                id="sme"
                                                placeholder="Enter SME"
                                                autoComplete="off"
                                                onChange={siteSMEHandler}
                                            />
                                        </FloatingLabel>
                                        {smeError && 
                                            <p className="indi-input-field-error-message">
                                                {smeError}
                                            </p>
                                        }
                                    </div>
                                </div>
                                <div className="indi-add-form-item d-flex flex-column indi-text-btn-row">
                                    <Form.Check
                                        type="switch"
                                        className="indi-input-switch-field"
                                        id="classicview"
                                        defaultChecked={classicview}
                                        label="New Interface"
                                        onChange={siteClassicviewHandler}
                                    />
                                </div>
                                <div className="indi-add-form-item d-flex flex-column indi-text-btn-row">
                                    <Form.Check
                                        type="switch"
                                        className="indi-input-switch-field"
                                        id="enablequiz"
                                        checked={enableQuiz}
                                        label="Enable Quiz"
                                        disabled={originalQuizValue}
                                        onChange={siteEnableQuizHandler}
                                    />
                                </div>
                                <div className="indi-add-form-item d-flex flex-column">
                                    <label className="mb-2 fw-bold">Select Folder:</label>
                                    <FolderTree
                                    selectionMode="single"
                                    selectedFolderId={selectedFolderId}
                                    setSelectedFolderId={setSelectedFolderId}
                                    currentFolderId={projectId} 
                                    expandedFolders={expandedFolders}
                                    toggleFolder={toggleFolder}
                                    type={props?.type}
                                    />
                                </div>  
                            </div>
                       

                            <div className="indi-add-footer">
                                <div className="indi-add-page-footer-btn-wrapper float-right">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={hideModal}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={submitSite}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            }
        </>
    );
};

export default CloneSitePage;
